<div class="avi-main-header-user-menu">
    <button
        avi-tooltip
        [showOnClick]="true"
        [tooltipControl$]="userMenuControl$"
        [positionsPriority]="menuPositions"
        class="avi-main-header-user-menu__button sel-user-menu-button"
    >
        <clr-spinner
            *ngIf="!username"
            clrInline
        ></clr-spinner>
        <cds-icon
            *ngIf="username"
            shape="user"
            size="24"
        ></cds-icon>
        <ng-template #aviTooltipContent>
            <div
                class="avi-main-header-user-menu__menu clr-wrapper"
                cdkTrapFocus
                [cdkTrapFocusAutoCapture]="true"
            >
                <avi-main-header-user-card
                    [username]="username"
                    [fullName]="fullName"
                    [email]="email"
                    [lastLogin]="lastLogin"
                    (onOpenMyAccountModal)="handleOpenMyAccountModal()"
                    (onOpenGenerateTokenDialog)="handleOpenGenerateTokenDialog()"
                ></avi-main-header-user-card>
                <ul class="avi-main-header-user-menu__list">
                    <li>
                        <button
                            (click)="handleOpenAboutDialog()"
                            class="sel-about-avi avi-main-header-user-menu__list-button"
                        >
                            {{ l10nKeys.aboutLabel | vtranslate }}
                        </button>
                    </li>
                    <li>
                        <button
                            (click)="goToAviDocumentation()"
                            class="sel-avi-api-documentation avi-main-header-user-menu__list-button"
                        >
                            {{ l10nKeys.aviApiDocumentationLabel | vtranslate }}
                        </button>
                    </li>
                    <li>
                        <button
                            (click)="goToCustomerPortal()"
                            class="sel-customer-portal avi-main-header-user-menu__list-button"
                        >
                            {{ l10nKeys.customerPortalLabel | vtranslate }}
                        </button>
                    </li>
                </ul>
                <div class="avi-main-header-user-menu__sign-out">
                    <button
                        (click)="handleLogout()"
                        class="sel-logout avi-main-header-user-menu__list-button"
                    >
                        {{ l10nKeys.signOutLabel | vtranslate }}
                    </button>
                </div>
            </div>
        </ng-template>
    </button>
</div>
